module.exports = __webpack_public_path__ + "static/img/14.08dbb26.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/14.png
// module id = crTR
// module chunks = 0